export interface SelectOption {
  value: string;
  label: string;
  description?: string;
}

export const VISUAL_STYLE_OPTIONS: SelectOption[] = [
  { value: 'lifestyle', label: 'Lifestyle', description: 'Aspirational real-life context' },
  { value: 'ugc', label: 'UGC', description: 'Raw, authentic, phone-camera aesthetic' },
  { value: 'us_vs_them', label: 'Us vs Them', description: 'Contrast against alternatives' },
  { value: 'offer_led', label: 'Offer Led', description: 'Discount, bundle, or limited-time deal' },
  { value: 'testimonial', label: 'Testimonial', description: 'Direct customer quote' },
  { value: 'benefits_highlight', label: 'Benefits Highlight', description: 'Stack key product benefits' },
];

/** @deprecated Use VISUAL_STYLE_OPTIONS instead */
export const FORMAT_OPTIONS = VISUAL_STYLE_OPTIONS;

export const CHANNEL_OPTIONS: SelectOption[] = [
  { value: 'meta', label: 'Meta', description: 'Facebook & Instagram' },
  { value: 'google', label: 'Google', description: 'Display & YouTube' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'programmatic', label: 'Programmatic', description: 'DSP display' },
];

export const SIZE_OPTIONS: SelectOption[] = [
  { value: '1080x1080', label: '1080×1080', description: 'Feed square' },
  { value: '1080x1350', label: '1080×1350', description: 'Feed portrait (best)' },
  { value: '1080x1920', label: '1080×1920', description: 'Stories / Reels' },
  { value: '1200x628', label: '1200×628', description: 'Right col / link ads' },
];
